<template>
  <div>
    <Nav />

    <router-view />

    <div class="md:mt-20"></div>
    <footer class="md:fixed bottom-0 w-full px-4 py-4 text-center bg-white text-gray-700 border-t shadow">
      Made with

      <a href="http://sachawilt.fr" target="_blank">
        <svg class="fill-content inline-block ml-1 w-3 text-gray-500 align-baseline" viewBox="0 0 576 512">
          <path d="M414.9 24C361.8 24 312 65.7 288 89.3 264 65.7 214.2 24 161.1 24 70.3 24 16 76.9 16 165.5c0 72.6 66.8 133.3 69.2 135.4l187 180.8c8.8 8.5 22.8 8.5 31.6 0l186.7-180.2c2.7-2.7 69.5-63.5 69.5-136C560 76.9 505.7 24 414.9 24z"></path>
        </svg>
      </a>
    </footer>
  </div>
</template>

<script>
import Nav from '@/components/Nav'

export default {
  components: {
    Nav,
  }
}
</script>
